import { Component } from '@angular/core';
import { ApplicationStateService } from '../../../services/application-state.service';
import { EditMoveableBookFeatureEvent } from '../../../utils/events/edit-moveable-book-feature-event';
import { CommunicationService } from '../../../services/communication.service';
import { FabricService } from '../../../services/fabric.service';
import { PageEditModeNamePipe } from '../../../pipes/page-edit-mode-name.pipe';

@Component({
    selector: 'app-current-mode',
    templateUrl: './current-mode.component.html',
    styleUrls: ['./current-mode.component.scss'],
    standalone: true,
    imports: [
        PageEditModeNamePipe
    ]
})
export class CurrentModeComponent {

    constructor(public applicationStateService: ApplicationStateService,
                private communicationService: CommunicationService,
                private fabricService: FabricService) {
    }

    dismissMode(): void {
        this.fabricService.setCurrentDrawAction(undefined);
        this.applicationStateService.isPageEditable = false;
        this.applicationStateService.pageEditMode = undefined;
        this.communicationService.announceMoveableBookFeatureEdit(new EditMoveableBookFeatureEvent());
        // @ts-ignore
        bootstrap.Dropdown.getOrCreateInstance('#drawing-tools').hide();
    }
}
